import { createContext, useContext } from "react";
import { taskUrl } from "./work";

type TaskRef = { key: string; project_key: string };

/**
 * Where a link to a task goes. On its own page that's the task page; inside a task list it's the same list with the
 * task open over it (`?task=KEY`), so links between tasks (subtasks, blockers) stay in that dialog.
 */
const TaskHref = createContext<(t: TaskRef) => string>(taskUrl);

export const TaskHrefProvider = TaskHref.Provider;

export function useTaskHref() {
  return useContext(TaskHref);
}

/** `PAY-12` → `PAY`. */
export const projectOfKey = (key: string) => key.slice(0, Math.max(0, key.lastIndexOf("-"))).toUpperCase();
